/* GameEditorViewActionsComponent.js */

'use strict';
const EventEmitter = require('events').EventEmitter;
const Renderer = require('./GameEditorViewActionsRenderer');

class GameEditorViewActionsComponent extends EventEmitter {
  constructor(logger) {
    super();
    this._logger = logger;
    this._renderer = new Renderer(this);
    this._registeredViewActions = [];

    this._registerListeners();
  }
  /*******************************************/
  /* START PRIVATE COMPONENT MODEL METHODS */
  /*******************************************/
  _registerListeners() {}
  _unregisterListeners() {}
  /*******************************************/
  /* END PRIVATE COMPONENT MODEL METHODS */
  /* START PUBLIC COMPONENT MODEL METHODS */
  /*******************************************/
  get renderer() {
    return this.getRenderer();
  }
  getRenderer() {
    return this._renderer;
  }
  get logger() {
    return this._logger;
  }
  shutdown() {
    this._unregisterListeners();
    return this._renderer.shutdown().then(
      () => {
        this._logger = undefined;
        this._registeredViewActions = undefined;
        this._renderer = undefined;
      },
      (err) => {
        this._logger.warn(err, 'GameEditorViewActionsComponent.shutdown() error');
      }
    );
  }
  get registeredViewActions() {
    return this.getRegisteredViewActions();
  }
  set registeredViewActions(actionsList) {
    this.setRegisteredViewActions(actionsList);
  }
  getRegisteredViewActions() {
    return this._registeredViewActions;
  }
  setRegisteredViewActions(actionsList, silent) {
    this._registeredViewActions = actionsList;
    if (!silent) {
      this.emit('NewViewActions');
    }
  }
  addViewAction(vaInfo, silent) {
    this._registeredViewActions.push(vaInfo);
    if (!silent) {
      this.emit('ViewActionAdded', vaInfo);
    }
  }
  removeViewAction(vaInfo) {
    this.emit('ViewActionRemoved', vaInfo);
  }
  enableViewAction(vaName) {
    this.emit('EnableViewAction', vaName);
  }
  disableViewAction(vaName) {
    this.emit('DisableViewAction', vaName);
  }
  showViewAction(vaName) {
    this.emit('ShowViewAction', vaName);
  }
  hideViewAction(vaName) {
    this.emit('HideViewAction', vaName);
  }
  requestViewAction(vaName, args) {
    this.emit('RequestViewAction', vaName, args);
  }
  clearViewActions() {
    this._registeredViewActions = [];
    return this._renderer.render();
  }
  /*******************************************/
  /* END COMPONENT MODEL METHODS */
  /* START HANDLER METHODS */
  /*******************************************/

  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE METHODS */
  /*******************************************/

  /*******************************************/
  /* END PRIVATE METHODS */
  /* START PUBLIC API METHODS */
  /*******************************************/

  /*******************************************/
  /* END PUBLIC API METHODS */
  /*******************************************/
}
module.exports = GameEditorViewActionsComponent;
